module.exports = __webpack_public_path__ + "img/login_banner.e670f8ce.png";